import { render, staticRenderFns } from "./BookingLinksIcon.vue?vue&type=template&id=9a4fd75e"
import script from "./BookingLinksIcon.vue?vue&type=script&lang=js"
export * from "./BookingLinksIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports